/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'waf';
const componentName = 'waf-user-overrides-badge';
const prefix = `${moduleName}.${componentName}`;

export const userOverridesLabel = `${prefix}.userOverridesLabel`;

export const ENGLISH = {
    [userOverridesLabel]: 'User Overrides',
};
